import { useEffect, useRef } from 'react'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { message } from 'antd'
import { YHModal } from '@/components/YHModal'
import { baseFleetModel } from '../fleetModel'
import { globalPrompt } from '@/components/message'
import { fleetService } from '../fleetService'

export const EditFleetModal = () => {
    const { editCarVisible, setEditCarVisible, loadData } = baseFleetModel()
    const formRef = useRef<IYhFormRef>()
    // const [formVal, setFormVal] = useState<any>({})

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            try {
                let { retData } = await fleetService.edit({
                    ...editCarVisible.value,
                    ...val,
                })
                setEditCarVisible({
                    visible: false,
                    value: {},
                })
                message.success(`修改成功！`)
                loadData()
                return retData
            } catch (error) {
                message.warning(error)
            }
        })
    }

    useEffect(() => {
        formRef.current?.setFieldsValue({ ...editCarVisible.value })
    }, [editCarVisible.value])

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '现场名称',
                fieldName: 'institutionName',
                span: 24,
                rules: [{ required: true, message: '请输入现场名称' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '地址',
                fieldName: 'address',
                span: 24,
                rules: [{ required: true, message: '请输入地址' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系人',
                fieldName: 'contacts',
                span: 24,
                rules: [{ required: true, message: '请输入联系人' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系人电话',
                fieldName: 'telephone',
                span: 24,
                rules: [{ required: true, message: '请输入联系人电话' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                fieldName: 'updateUser',
                span: 24,
            },
        ],
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        // formValues: formVal,
        onChange,
        boxs: [formItem],
    }
    const onClose = () => {
        globalPrompt('modal', {
            title: '修改车辆现场',
            type: 'warning',
            text: '您正在修改的车辆现场记录还没保存...是否关闭？',
            okText: '确认关闭',
            onOk: () =>
                setEditCarVisible({
                    visible: false,
                    value: {},
                }),
            cancelText: '继续修改',
            // onCancel: () => {
            //     formRef.current?.resetFields()
            //     return
            // },
        })
    }
    return (
        <YHModal
            visible={editCarVisible.visible}
            title="您正在修改车辆现场..."
            cancelText="取消修改"
            okText="确定修改"
            onCancel={onClose}
            onOk={onOk}
            width={500}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
